import OwnColor from './OwnColor';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var currentScreenStyle = props.currentScreenStyle;
  var currentList = props.currentList;
  var anItem = props.anItem;
  var formulaPieceInGeneral = props.formulaPieceInGeneral;
  var submitGeneric = props.submitGeneric;
  var columnWidth = props.columnWidth;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var addToExtraScreen = props.addToExtraScreen;
  var stylePath = props.stylePath;
  var organicChanges = props.organicChanges;

  var currentColor;
  if (currentScreenStyle){
    currentColor = currentScreenStyle[anItem.i];
  }
  var allowFormula = false;
  if (anItem.f){
    allowFormula = formulaPieceInGeneral(anItem.i, anItem.n, {t:'Color'});
  }
  function changeGeneric(t, x1){
    return function(e){
      submitGeneric({t, v:e}, x1);
    }
  }

  var gotForm = false;
  if (allowFormula){
    gotForm = true;
  }
  return (<td >
            <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'color', gotForm, n:anItem.n}}/>
        {anItem.n}<center><OwnColor currentList={currentList} submitColor={changeGeneric('raw', anItem.i)} currentStyle={currentColor} allowFormula={allowFormula} e={anItem.e} width={columnWidth - 20} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} colorType={anItem.i} logPath={stylePath} organicChanges={organicChanges} styles={currentScreenStyle} /></center></td>)
}


export default App;
